import React from 'react';
import Image from "next/image";
import { useRouter } from 'next/router';
import { stringToSlug } from 'functions/slug';

interface StoreCardPorps {
  data: {
    category_image_url: string;
    slug: string;
    name: string;
    main_address: string;
    state: string;
  };
}
export default function StoreCard({ data }: StoreCardPorps) {
  const router = useRouter();
  const storeLink = (url: string) => {
    return (
      (router.locale !== 'international' ? '/' + router.locale : '') +
      url
    );
  }

  const isFitzroy = data.name.toLowerCase().includes('fitzroy');

  return (
    <a href={storeLink(`/stores/${stringToSlug(data.name)}`)}>
      <div className="relative flex flex-col h-full">
        {isFitzroy && (
          <div className="absolute top-[-40px] w-full h-[200px] z-10">
            <Image
              objectFit="contain"
              fill
              quality={98}
              src="/images/fitztroy_move_store.png"
              alt="Fitzroy's Moving Announcement"
              className="w-full h-full"
            />
          </div>
        )}
        <div className="relative flex w-full h-[392px]">
          <Image
            objectFit="cover"
            layout="fill"
            src={data.category_image_url || '/images/stores/ss.png'}
            alt={data.name}
            quality={60}
            sizes="(max-width: 768px) 80vw, (max-width: 1200px) 50vw, 220px"
            className="w-full h-full"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/50" />
        </div>
        <div className="absolute bottom-0 flex flex-col justify-center p-5 smx:p-2 w-full">
          <div className="flex flex-row items-center w-full justify-between">
            <h3 className="text-center mt-2 font-sans text-[38px] text-white font-bold mb-2">
              {data.name}
            </h3>
            <div className="text-center mt-2 font-sans text-[16px] text-white font-medium mb-2  bg-[#fff] rounded-[6px] px-[12px] py-[4px] text-[#2A2A2A]">
              {data.state}
            </div>
          </div>
        </div>
      </div>
    </a>
  );
}
